import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Banner from 'components/HyperLocalPages/DirectoryPage/BOTLocation/components/Banner'
import { List, ListItem, CustomLink, Description, Wrapper } from '../../Shared.styles'
import capitalize from 'lodash/capitalize'

const BOTStoreCityList = ({ title, image, description, cities = [], secondTitle, hasCities }) =>
  <Wrapper>
    <Banner title={ title } image={ image } />
    <Description>{ description }</Description>
    <Title>{ secondTitle }</Title>
    { !hasCities && <Placeholder>Sorry, there are no stores in this state yet.</Placeholder> }
    { hasCities && (
      <List>
        { cities.map(place =>
          <ListItem key={ place.cityName }>
            <CustomLink to={ place.cityDetailUrl }>{ capitalize(place.cityName) }</CustomLink>
          </ListItem>
        )}
      </List>
    )}
  </Wrapper>

BOTStoreCityList.propTypes = {
  cities: PropTypes.arrayOf(PropTypes.shape()),
  description: PropTypes.string,
  hasCities: PropTypes.bool,
  image: PropTypes.string,
  secondTitle: PropTypes.string,
  title: PropTypes.string
}

export default BOTStoreCityList

const Title = styled.h2`
  text-align: center;
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 25px 0;
  transform: scale(1, 1.3);
  ${Media.mobile`
    padding: 0 16px;
  `}
`

const Placeholder = styled.p`
  text-align: center;
  margin: 0;
`
